import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Typography,
  Tag
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { createLocationApi, deleteLocationApi, getLocationApi, updateLocationApi } from '../../services/locationApi';
import { toast } from 'react-toastify';

const { Title } = Typography;
const { TextArea } = Input;

const LocationManagement = () => {
  const [locations, setLocations] = useState([
    {
      id: 1,
      name: 'New York Office',
      address: '123 Broadway, New York, NY 10001',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'USA',
      description: 'Main headquarters office'
    },
    {
      id: 2,
      name: 'Los Angeles Branch',
      address: '456 Sunset Blvd, Los Angeles, CA 90028',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90028',
      country: 'USA',
      description: 'West coast operations center'
    }
  ]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);
  const [viewingLocation, setViewingLocation] = useState(null);
  const [form] = Form.useForm();



  useEffect(()=>{
handleLocationFetch()
  },[])

  const handleLocationFetch = async ()=>{
    try {
        let res = await getLocationApi()
        if(!res?.sucess) return 
        setLocations(res?.data)
    } catch (error) {
        return
    }
  }


  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    // {
    //   title: 'City',
    //   dataIndex: 'city',
    //   key: 'city',
    //   sorter: (a, b) => a.city.localeCompare(b.city),
    // },
    // {
    //   title: 'State',
    //   dataIndex: 'state',
    //   key: 'state',
    //   render: (state) => <Tag color="blue">{state}</Tag>,
    // },
    // {
    //   title: 'Country',
    //   dataIndex: 'country',
    //   key: 'country',
    //   render: (country) => <Tag color="green">{country}</Tag>,
    // },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          {/* <Button
            icon={<EyeOutlined />}
            onClick={() => handleView(record)}
            type="link"
          >
            View
          </Button> */}
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            type="link"
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this location?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<DeleteOutlined />}
              type="link"
              danger
            >
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {

    try {
       
  
    setEditingLocation(null);
    setIsModalVisible(true);
    form.resetFields();
      } catch (error) {
        
    }
  };

  const handleEdit = (location) => {
    setEditingLocation(location);
    setIsModalVisible(true);
    form.setFieldsValue(location);
  };

  const handleView = (location) => {
    setViewingLocation(location);
    setIsViewModalVisible(true);
  };

  const handleDelete = async (id) => {
    let res = await deleteLocationApi(id)
    if(!res?.sucess) return toast.error('Location not deleted')
    setLocations(locations.filter(location => location._id !== id));
    toast.success('Location deleted successfully!');
  };

  const handleModalOk = async () => {
    form.validateFields().then(values => {
      if (editingLocation) {
        // Update existing location


         updateLocationApi(values._id,values).then(res=>{


            if(!res?.sucess) return toast.error('Not able to create!')
       setLocations(locations.map(location =>
          location.id === editingLocation.id
            ? { ...location, ...values }
            : location
        ));
        toast.success('Location updated successfully!');


         }).catch(err=>{
         return  toast.error('Not able to Update')
         })
        
      } else {
        // Add new location
        const newLocation = {
          id: Math.max(...locations.map(l => l.id), 0) + 1,
          ...values
        };
        

         createLocationApi(values).then(res=>{
            if(!res?.sucess) return toast.error('Not able to create!')
        setLocations([...locations, newLocation]);
        toast.success('Location added successfully!');
         }).catch(err=>{
         return  toast.error('Not able to create')
         })
       
      }
      setIsModalVisible(false);
      form.resetFields();
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleViewModalCancel = () => {
    setIsViewModalVisible(false);
    setViewingLocation(null);
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
          <Col>
            <Title level={2} style={{ margin: 0 }}>Location Management</Title>
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAdd}
              size="large"
            >
              Add Location
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={locations}
          rowKey="id"
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} locations`,
          }}
        />

        {/* Add/Edit Modal */}
        <Modal
          title={editingLocation ? 'Edit Location' : 'Add New Location'}
          open={isModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          width={600}
        >
          <Form
            form={form}
            layout="vertical"
            name="locationForm"
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="Location Name"
                  rules={[
                    { required: true, message: 'Please enter location name!' }
                  ]}
                >
                  <Input placeholder="Enter location name" />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[
                    { required: true, message: 'Please enter address!' }
                  ]}
                >
                  <Input placeholder="Enter full address" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="city"
                  label="City"
                  rules={[
                    { required: true, message: 'Please enter city!' }
                  ]}
                >
                  <Input placeholder="Enter city" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="state"
                  label="State"
                  rules={[
                    { required: true, message: 'Please enter state!' }
                  ]}
                >
                  <Input placeholder="Enter state" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="zipCode"
                  label="ZIP Code"
                  rules={[
                    { required: true, message: 'Please enter ZIP code!' }
                  ]}
                >
                  <Input placeholder="Enter ZIP code" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="country"
                  label="Country"
                  rules={[
                    { required: true, message: 'Please enter country!' }
                  ]}
                >
                  <Input placeholder="Enter country" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="description"
                  label="Description"
                >
                  <TextArea
                    rows={3}
                    placeholder="Enter description (optional)"
                  />
                </Form.Item>
              </Col>
            </Row> */}
          </Form>
        </Modal>

        {/* View Modal */}
        <Modal
          title="Location Details"
          open={isViewModalVisible}
          onCancel={handleViewModalCancel}
          footer={[
            <Button key="close" onClick={handleViewModalCancel}>
              Close
            </Button>
          ]}
          width={600}
        >
          {viewingLocation && (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Title level={4} style={{ color: '#1890ff', marginBottom: '8px' }}>
                    {viewingLocation.name}
                  </Title>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <strong>Address:</strong>
                </Col>
                <Col span={16}>
                  {viewingLocation.address}
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <strong>City:</strong>
                </Col>
                <Col span={16}>
                  {viewingLocation.city}
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <strong>State:</strong>
                </Col>
                <Col span={16}>
                  <Tag color="blue">{viewingLocation.state}</Tag>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <strong>ZIP Code:</strong>
                </Col>
                <Col span={16}>
                  {viewingLocation.zipCode}
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <strong>Country:</strong>
                </Col>
                <Col span={16}>
                  <Tag color="green">{viewingLocation.country}</Tag>
                </Col>
              </Row>

              {viewingLocation.description && (
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <strong>Description:</strong>
                  </Col>
                  <Col span={16}>
                    {viewingLocation.description}
                  </Col>
                </Row>
              )}
            </div>
          )}
        </Modal>
      </Card>
    </div>
  );
};

export default LocationManagement;